import Product from "./Product";
import {useState} from "react";
import {ProductInterface} from "../../interfaces/catalog/ProductInterface";
import {CategoryInterface} from "../../interfaces/catalog/CategoryInterface";
import {SortType} from "../../utils/productSort";
import ProductListSort from "./ProductListSort";

export default function Products({products, toggleFilters, sortType, setSortType}: { products: ProductInterface[], toggleFilters: () => void, sortType: SortType, setSortType: (sortType: SortType) => void })
{
    const [isGridMode, setIsGridMode] = useState(true)

    return (<div className="col-12 col-lg-8 col-xl-9 ">
        <div className="d-flex mb-3 pt-3 w-100">
            <div className="d-flex align-items-center gap-2 catalog__ftr-open d-lg-none me-4" onClick={toggleFilters}>
                <img src="/images/icon-ftr-open.svg" alt=""/>
                <span style={{borderBottom: '1px dashed currentColor'}}>Все фильтры</span>
            </div>
            <ProductListSort sortType={sortType} setSortType={setSortType}/>
            <div className="d-flex gap-2 ms-auto">
                <div className={'catalog__btn-grid ' + (isGridMode ? '_active' : '')} onClick={() => setIsGridMode(true)}>
                    <svg width="28" height="28" viewBox="0 0 28 28" fill="none"
                         xmlns="http://www.w3.org/2000/svg">
                        <path d="M4.66699 4.6665H12.8337V12.8332H4.66699V4.6665Z" fill="#FC5521"/>
                        <path d="M15.167 4.6665H23.3337V12.8332H15.167V4.6665Z" fill="#FC5521"/>
                        <path d="M4.66699 15.1665H12.8337V23.3332H4.66699V15.1665Z" fill="#FC5521"/>
                        <path d="M15.167 15.1665H23.3337V23.3332H15.167V15.1665Z" fill="#FC5521"/>
                    </svg>
                </div>
                <div className={'catalog__btn-grid ln ' + (!isGridMode ? '_active' : '')} onClick={() => setIsGridMode(false)}>
                    <svg width="28" height="28" viewBox="0 0 28 28" fill="none"
                         xmlns="http://www.w3.org/2000/svg">
                        <path d="M4.66699 5.8335H8.16699V8.16683H4.66699V5.8335Z" fill="#A6A6A6"/>
                        <path d="M4.66699 10.5H8.16699V12.8333H4.66699V10.5Z" fill="#A6A6A6"/>
                        <path d="M4.66699 15.1665H8.16699V17.4998H4.66699V15.1665Z" fill="#A6A6A6"/>
                        <path d="M4.66699 19.8335H8.16699V22.1668H4.66699V19.8335Z" fill="#A6A6A6"/>
                        <path d="M9.33301 5.8335H23.333V8.16683H9.33301V5.8335Z" fill="#A6A6A6"/>
                        <path d="M9.33301 10.5H23.333V12.8333H9.33301V10.5Z" fill="#A6A6A6"/>
                        <path d="M9.33301 15.1665H23.333V17.4998H9.33301V15.1665Z" fill="#A6A6A6"/>
                        <path d="M9.33301 19.8335H23.333V22.1668H9.33301V19.8335Z" fill="#A6A6A6"/>
                    </svg>
                </div>
            </div>
        </div>
        <div className={'gx-3 gx-md-6 row gy-3 ' + (!isGridMode && 'catalog-row-rect')}>
            {products.map(product =>  <div className="col-6 col-md-4 col-xxl-3 col-sm-6 prod-card"><Product product={product} /></div>)}
        </div>
    </div>)
}